const MILES_PER_METER = .000621371192 // .000621371192 is converting meters to miles
const METERS_PER_MILE = 1/MILES_PER_METER;
const METERS_PER_KM = 1000;
const KM_PER_METER = 1/METERS_PER_KM;
const KG_PER_POUND = 0.453592;
const POUNDS_PER_KG = 1/KG_PER_POUND;

export const MilesToKm = miles => miles * METERS_PER_MILE * KM_PER_METER;
export const KmToMiles = km => km * METERS_PER_KM * MILES_PER_METER;
export const KgToPounds = kg => kg * POUNDS_PER_KG;

export const MeasurementSystems = Object.freeze({
  IMPERIAL: 'imperial',
  METRIC: 'metric',
});

export default {
  MeasurementSystems,
  MilesToKm,
  KmToMiles,
  KgToPounds,
}



// WEBPACK FOOTER //
// ./src/types/measurements.js